import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { CustomFieldsModule } from 'src/app/components/custom-fields/custom-fields.module';
import { SharedDirectivesModule } from 'src/directives/shared-directives.module';

import { AvatarModule } from '../components/avatar/avatar.module';

import { DisplayInboundEmailRoutingModule } from './display-inbound-email-routing.module';
import { DisplayInboundEmailComponent } from './display-inbound-email.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DisplayInboundEmailRoutingModule,
    CustomFieldsModule,
    AvatarModule,
    NgxTippyModule,
    SharedDirectivesModule,
  ],
  declarations: [DisplayInboundEmailComponent],
})
export class DisplayInboundEmailModule {}
